import React, { useState, useRef } from "react";
import jsPDF from "jspdf";

import html2canvas from "html2canvas";

import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import { BASE_URL } from "../Apis/apiConfig";

export default function PendingBill() {

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const [loading, setLoading] = useState(false);
  const [pendingBills, setPendingBills] = useState([]);


  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />

      <div className="main-layout">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

        <main className="content-area">
          <SubHeader />
        </main>
      </div>
    </div>
  );
}